module.exports = __webpack_public_path__ + "static/media/dashboard.fc69da9a.jpg";